export type Gender = "male" | "female" | "other";

export type User = {
  id: string;
  name: string;
  email: string;
  gender: Gender;
  age: number;
  avatarUrl: string | null;
  region: number | null;
};

export const toGender = (value: number): Gender => {
  switch (value) {
    case 0:
      return "female";
    case 1:
      return "male";
    default:
      return "other";
  }
};
